module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAASBAMAAABCyVggAAAAAXNSR0IB2cksfwAAAA9QTFRFAAAA////////////////j0LeaAAAAAV0Uk5TABDP/9Addq/1AAAAN0lEQVR4nGNgYGBgVGJAACETBJtR2RFZQoACCQZnYzhQQOY4MIgYISljdFZEcgy5UkgcRhcoAwCt8Qo5TMNWXQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/side-menu-back.png
// module id = 951
// module chunks = 0